import { EXPERIENCE_TYPE_GM, EXPERIENCE_TYPE_KITCHEN, EXPERIENCE_TYPE_LAUNDRY } from './base-configuration';

export const MOBILE_PLACEHOLDER_HEIGHT = {
  [EXPERIENCE_TYPE_GM]: {
    pricePlaceholderHeight: '48px',
    summaryPlaceholderHeight: '211px',
    consumerCardPlaceholderHeight: '63px'
  },
  [EXPERIENCE_TYPE_KITCHEN]: {
    pricePlaceholderHeight: '92px',
    summaryPlaceholderHeight: '323px',
    consumerCardPlaceholderHeight: '42px'
  },
  [EXPERIENCE_TYPE_LAUNDRY]: {
    pricePlaceholderHeight: '92px',
    summaryPlaceholderHeight: '323px',
    consumerCardPlaceholderHeight: '42px'
  }

};

export const DESKTOP_PLACEHOLDER_HEIGHT = {
  [EXPERIENCE_TYPE_GM]: {
    pricePlaceholderHeight: '48px',
    summaryPlaceholderHeight: '214px',
    consumerCardPlaceholderHeight: '63px'
  },
  [EXPERIENCE_TYPE_KITCHEN]: {
    pricePlaceholderHeight: '48px',
    summaryPlaceholderHeight: '326px',
    consumerCardPlaceholderHeight: '42px'
  },
  [EXPERIENCE_TYPE_LAUNDRY]: {
    pricePlaceholderHeight: '48px',
    summaryPlaceholderHeight: '326px',
    consumerCardPlaceholderHeight: '42px'
  }
};
